import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import RequireSignup from "../views/authentication/RequireSignup/RequireSignup";
import { toggleModal } from "../shared-components/modals/actions";

function RequireSignupModal({ eventSource }) {
  return (
    <RequireSignup nextUrl={window.location.href} eventSource={eventSource} />
  );
}

RequireSignupModal.propTypes = {
  eventSource: PropTypes.shape({
    page: PropTypes.object,
    component: PropTypes.string
  })
};

export const useRequireSignupModal = () => {
  const dispatch = useDispatch();

  const openRequireSignupModal = (classes = "", eventSource) => {
    const component = () => <RequireSignupModal eventSource={eventSource} />;
    component.displayName = "RequireSignupModal";

    dispatch(
      toggleModal({
        className: `signup-modal ${classes}`,
        disableScroll: true,
        useGlobalModalContainer: true,
        component
      })
    );
  };

  return { openRequireSignupModal };
};
